module.exports = __webpack_public_path__ + "img/Karol.ce3ba1cb.png";